<template lang="pug">
.entity-relation
  template(v-if="loading")
    v-skeleton-loader(
      class="mx-auto my-3"
      type="article"
    )
  template(v-else)
    slot(name="EntityRelation", v-bind="{ path, parentPath: parentPath }")
      template(v-if="!relation.multiple")
        app-entity-controller(
          v-if="!entity.extra && notController",
          :path="path === entity.name ? null : path",
          :vertical="vertical === false ? false : true",
          :extraLoad="extraLoads",
          :extraWhere="extraWheres",
          v-bind="{ extraData, invert, relation, entity, parentInstance, disabled, chips, selector, selectorOnly, showInfo, parent, ignoreFields, isActive, parentPath, modalInstance}",
          @close="$emit('close')",
        )
          slot(v-for="(_, name) in $slots", :name="name", :slot="name")
          template(v-for="(_, name) in $scopedSlots", :slot="name", slot-scope="slotData")
            slot(:name="name" v-bind="slotData")
        app-entity(
          :extra-data="extraData",
          v-else
          :invert="invert",
          @close="$emit('close')",
          :relation="relation",
          :path="path === entity.name ? null : path",
          :entity="entity",
          v-bind="{ disabled, chips, selector, selectorOnly, showInfo,  parent , ignoreFields, isActive, parentPath, modalInstance }",
          :parentInstance="parentInstance"
        )
          template(v-for="(_, slot) in $slots")
            template(:slot="slot")
              slot(:name="slot")
      app-entity-list(
        v-else-if="relation.multiple && relation.type != 'OrderLine'",
        :extra-data="extraData",
        :invert="invert",
        @close="$emit('close')",
        :relation="relation",
        :path="path",
        :entity="entity",
        :isSection="isSection",
        v-bind="{ ...$attrs, disabled, chips, parentInstance, selectorOnly, showInfo, parent, ignoreFields, isActive, parentPath, modalInstance }"
      )
        template(v-for="(_, slot) in $slots")
          template(:slot="slot")
            slot(:name="slot")

      app-orderlines-tab(
        v-else,
        :extra-data="extraData",
        :invert="invert",
        @close="$emit('close')",
        :relation="relation",
        :path="path",
        :entity="entity",
        :isSection="isSection",
        v-bind="{ disabled, errors, chips, parentInstance, selectorOnly, showInfo, parent, ignoreFields, isActive, parentPath, modalInstance, orderlineStatuses, handlingUnitsList, relations }"
      )
        template(v-for="(_, slot) in $slots")
          template(:slot="slot")
            slot(:name="slot")

</template>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'
export default {
  mixins: [EntityMixin],
  props: {
    'extraLoads': {
      type: Array,
      default: () => ([])
    },
    'extraWheres': {
      type: Array,
      default: () => ([])
    },
    'errors': {
      type: Object,
      default: () => ({})
    },
    'invert': null,
    'chips': null,
    'parentInstance': null,
    'parent': null,
    'entity': null,
    'relation': null,
    'path': null,
    'parentPath': null,
    'selector': null,
    'selectorOnly': null,
    'showInfo': null,
    'extraData': null,
    'isSection': null,
    'isActive': null,
    'orderlineStatuses': {
      type: Array,
      default: () => ([])
    },
    'handlingUnitsList': {
      type: Array,
      default: () => ([])
    },
    'vertical': null,
  },
  data: function () {
    return {
      loading: true,
      //
    }
  },
  async created() {
    try {
      this.loading = true;
      var entity = {}
      var extraLoad = this.extraLoad || []
      if (this.parentInstance && this.parentInstance.id && (this.path !== this.entity.name) && _.isEmpty(this.instance)){
          entity = (await axios.get(this.parent.name + '/' + this.parentInstance.id,  {
             params: {
              Load: [...extraLoad, ...this.$relationLoads(this.parent, this.entity), this.relation.name + (this.entity.name === 'ExtraField' ? '' : this.$isExtraDateable(this.entity) ? '.ExtraData' : '')]
            }
          })).data
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: entity[this.relation.name]  })
      }
      if (!this.instance && this.path !== this.entity.name)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: this.relation.multiple ? [] : entity[this.relation.name] })
    } catch (e) {
      console.log(this.$cleanString(e));
    } finally {
      this.loading = false;
    }
  },
  computed: {
    notController() {
      return !['Package'].includes(this.entity.name);
    },
  },
}
</script>
